<template>
  <div>
    <div class="bg-white padding-16">
      <div class="text-18 text-bold">对本次行程有什么不满</div>
      <div class="margin-top-12 text-grey">请选择您要投诉的原因</div>
    </div>
    <div>
      <div class="bg-white margin-tb-12 margin-lr-8 radius padding-12"
      :class="[ form.activeId === item.id ? 'active' : '' ]"
      v-for="item in tagsList"
      :key="item.id"
      @click="$set(form, 'activeId', item.id); $set(form, 'tagName', item.name);"
      >{{ item.name }}</div>
      <div class="bg-white margin-tb-12 margin-lr-8 radius padding-12">
        <textarea class="text-content" maxlength="50" placeholder="请描述详细原因（50字以内)" v-model="form.content"></textarea>
      </div>
    </div>
    <div class="bg-white margin-tb-12 margin-lr-8 radius padding-12">
      <div class="text-grey margin-bottom-12">照片上传： {{ imgList.length }} / 9</div>
      <van-uploader
      v-model="imgList"
      :before-read="beforeRead"
      :max-size="3072 * 1024"
      :max-count="9"
      :multiple="true"
      accept="image/*"
      @oversize="onOversize"
      />
    </div>
    <div class="padding-16">
      <van-button :loading="loading" block type="primary"  @click="onSubmit">提交</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader } from 'vant'

import { fetchComplaintTags, uploadFile, submitComplaint } from 'api/service'
import { fetchDetail as fetchOrderDetail } from 'api/order'

Vue.use(Uploader)

let firstPage = false
export default {
  data ({ $route }) {
    return {
      tagsList: [], // 投诉标签列表
      imgList: [],
      form: {
        orderId: Number($route.params.orderId),
        orderType: Number($route.params.orderType)
      },
      loading: false,
      orderDetail: {},
      firstPage: true
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!from.name || !from.meta.title) {
      firstPage = true
    }
    next()
  },
  created () {
    this.fetchComplaintTags()
    this.fetchOrderDetail()
  },
  methods: {
    onBack () {
      try {
        this.$router.back()
      } catch (error) {
        this.$router.replace('/service/home')
      }
    },
    async fetchOrderDetail () {
      this.orderDetail = await fetchOrderDetail({
        bizType: this.form.orderType,
        bizId: this.form.orderId
      })
    },
    async fetchComplaintTags () {
      const list = await fetchComplaintTags({
        code: 'complaint',
        roleType: this.form.orderType
      })
      this.tagsList = list
    },
    beforeRead (file) {
      const typeList = ['image/jpeg', 'image/png']
      if (!typeList.includes(file.type)) {
        this.$toast('请上传jpg/png格式照片')
        return false
      }
      return true
    },
    onOversize (file) {
      this.$toast('文件大小不能超过3M')
    },
    async onSubmit () {
      if (!this.form.activeId) {
        this.$toast('必须选择原因')
        return
      }
      if (!this.form.content) {
        this.$toast('请输入详细信息')
        return
      }
      try {
        await this.$dialog.confirm({
          title: '投诉提醒',
          message: '请根据实际情况进行投诉，平台会根据实际情况进行调查，若恶意投诉会收到平台的追责和惩罚。',
          confirmButtonText: '同意',
          cancelButtonText: '放弃',
          confirmButtonColor: 'var(--primary)',
          cancelButtonColor: 'var(--light-grey1)'
        })

        let imgList = []
        if (this.imgList.length) {
          const promiseList = this.imgList.map(item => {
            return uploadFile(item.file)
          })
          try {
            this.loading = true
            const res = await Promise.all(promiseList)
            imgList = res.map(item => item.url)
          } catch (error) {
            this.$toast('图片上传失败')
            this.loading = false
            return
          }
        }
        try {
          const { orderId, tagName, content } = this.form
          const { startAddress, endAddress, predictArriveOriginTime, orderState, bizType, passengerUserId, driverUserId } = this.orderDetail
          await submitComplaint({
            orderId,
            passengerUserId,
            driverUserId,
            title: tagName,
            content,
            startAddress,
            endAddress,
            orderType: bizType,
            orderStatus: orderState,
            orderTime: predictArriveOriginTime,
            imageUrls: imgList,
            questionType: 'complain'
          })

          this.$toast({
            type: 'success',
            message: '提交成功'
          })
          this.$dialog.alert({
            message: '后续进度请在客服中心——服务进度中查看',
            confirmButtonText: '我知道了',
            confirmButtonColor: 'var(--primary)'
          }).then(() => {
            if (firstPage) {
              this.$router.replace('/service/home')
            } else {
              this.$router.back()
            }
          })
        } catch (error) {

        } finally {
          this.loading = false
        }
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  border: 1px solid $primary;
  color: $primary;
}
.text-content {
  display: block;
  width: 100%;
  border: none;
  resize: none;
  min-height: 160px;
}
</style>
